import React, { FunctionComponent, memo } from "react";
import { Box } from "@mui/material";
import { C2DSFieldKey } from "@investorRequest/models";
import { useC2DSErrors } from "@investorRequest/hooks/useC2DSFieldError";

interface Props {
  fieldKey: C2DSFieldKey;
}

// LPC-10764: Renders C2DS validation messages for a single field.
// Multi-line messages (joined with "\n" by the parser) are rendered as separate Boxes.
// Uses MUI warning.main color via sx so visual styling is consistent across all
// wire-form contexts regardless of which external CSS files have been loaded.
const C2DSFieldErrorMessages: FunctionComponent<Props> = ({ fieldKey }) => {
  const { hasFieldError, getFieldErrorMessage } = useC2DSErrors();

  if (!hasFieldError(fieldKey)) return null;

  const messages = getFieldErrorMessage(fieldKey).split("\n");

  return (
    <>
      {messages.map((msg) => (
        <Box key={msg} mt={1} color="warning.main" fontSize={12}>
          {msg}
        </Box>
      ))}
    </>
  );
};

export default memo(C2DSFieldErrorMessages);
